module.exports = __webpack_public_path__ + "img/magento-services-integration_medium@2x.ba52b132.jpg";